import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_m2upumjee3: FaireBrandEntity = {
  token: "b_m2upumjee3",
  type: "brand",
  name: "Mahjong & Magnolias",
  avatarUrl:
    "https://cdn.faire.com/fastly/7d51458e0a9acb050ccbb19d50a72049ffad133565265ba19859b6c14ed17786.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e8324a1bc8380a79e240410435b82d5c957a1a68ee3521d3d0be29c040305297.png",
  logoUrl:
    "https://cdn.faire.com/fastly/7d51458e0a9acb050ccbb19d50a72049ffad133565265ba19859b6c14ed17786.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e8324a1bc8380a79e240410435b82d5c957a1a68ee3521d3d0be29c040305297.png",
  location: "Franklin, TN, USA",
  minimumOrderDollars: 250,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "Mahjong & Magnolias is an online lifestyle account that showcases everything you need to host a stylish and inviting mahjong gathering. Their thoughtfully curated collections of table decor, fashion pieces, and mahjong accessories are selected to add just the right touch of tradition with modern day entertaining. They believe that hosting friends for mahjong is not just about playing the game, but an opportunity to dress up yourself and your table.  ",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:45.433Z",
    importedBy: "entity-db-cli",
  },
};
